import { GetterTree } from 'vuex';
import { CastListState, RootState } from '@/store/types';

const getters: GetterTree<CastListState, RootState> = {
    getCastList: (state: CastListState) => {
        return state.castList;
    },
    getNewCommerList: (state: CastListState) => {
        return state.newCommerList;
    },
};

export default getters;